import { IMedication } from 'API';
import { useMedications } from 'Hooks';
import { useEffect, useState } from 'react';
import { isExpired } from 'Utils';
import { ExpiredMedicationsList } from './ExpiredMedicationsList';
import { ExpiredMedicationsTitle } from './ExpiredMedicationsTitle';

export const ExpiredMedicationsMobile = () => {
  const { medications } = useMedications();

  const [expiredMedications, setExpiredMedications] = useState<IMedication[]>(
    []
  );

  useEffect(() => {
    setExpiredMedications(
      medications.filter((medication) =>
        isExpired(new Date(medication.nextrefreshdate))
      )
    );
  }, [medications]);

  return (
    <>
      <ExpiredMedicationsTitle
        numOfExpiredMedications={expiredMedications.length}
      />
      <ExpiredMedicationsList expiredMedications={expiredMedications} />
    </>
  );
};
